import PQueue from 'p-queue';
import { createContext } from 'react';

export interface BackgroundJobContextReturnValues {
  queue: PQueue;
  addJob: (job: () => any) => Promise<any>;
}

export const BackgroundJobContext = createContext<BackgroundJobContextReturnValues | undefined>(undefined);
